import { render, staticRenderFns } from "./DetalhamentoCategoriaDialog.vue?vue&type=template&id=a33c9704&scoped=true"
import script from "./DetalhamentoCategoriaDialog.vue?vue&type=script&lang=js"
export * from "./DetalhamentoCategoriaDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalhamentoCategoriaDialog.vue?vue&type=style&index=0&id=a33c9704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33c9704",
  null
  
)

export default component.exports